import UpdateEvaluacionAnualAdapter from './adapters/UpdateEvaluacionAnualAdapter'

class UpdateEvaluacionAnual {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute({
    idEvaluacionAnual,
    idPersonalEvaluado,
    idPersonalEvaluador,
    estatus,
    fecha,
    tipoEvaluacion,
    reactivos,
  }) {
    const payload = UpdateEvaluacionAnualAdapter.toDto({
      idPersonalEvaluador,
      estatus,
      fecha,
      reactivos,
      tipoEvaluacion,
    })

    return this.#repository.update(idPersonalEvaluado, idEvaluacionAnual, payload)
  }
}

export default UpdateEvaluacionAnual
